var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"router-button",class:'btn-'+_vm.themeColor,attrs:{"to":_vm.to,"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.batchNo)?_c('span',{staticClass:"batch"},[_vm._v(_vm._s(_vm.batchNo))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }